module.exports = __webpack_public_path__ + "img/meter-offline-noti.6827a674.png";